import React, { useState } from "react";
import {
  makeStyles,
  Button,
  Box,
  InputAdornment,
  Tabs,
  Tab,
  withStyles,
  FormControlLabel,
  Checkbox,
  Divider,
  Grid,
  MenuItem,
  Radio,
  TextField as TextField2,
} from "@material-ui/core";
import TitleText from "../components/reusableComponents/TitleText";
import { Field, Form, Formik, FieldArray } from "formik";
import DatePicker from "@mui/lab/DatePicker";
import { TextField } from "formik-material-ui";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { setMealInfo, setPayment, togglePGModal } from "../reducers/UiReducer";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import seat from "../assets/images/seat.png";
import meal from "../assets/images/meal.png";
import {
  FlightBookEtravDispatch,
  FlightBookDispatch,
  FlightTicketLCCDispatch,
  FlightAddBookingDispatch,
} from "../reducers/HomeReducer";
import paymenthandle from "./HandelPayment";
import { walletBalanceAgentDispatch } from "../reducers/UserReducer";
import ErrorModal from "../components/reusableComponents/ErrorModal";
import etravBooking from "./EtravBookingForm";
import tbobooking from "./TBOBookingLCCForm";
import tbobookingnonlcc from "./TBOBookingNonLCC";
import addBooking from "./FormAddBooking";
import BookingAlreadyPNRModal from "../components/reusableComponents/BookingAlreadyPNRModal";
import Seat from "../components/reusableComponents/Seat";
import WorldlinePG from "../components/reusableComponents/WorldlinePG";
import addBookingReturn from "./FormAddBookingReturn";
import addINtBooking from "./FormIntAddBooking";
import { setBaggage } from "../reducers/UiReducer";
import { FlightBookTripJackDispatch } from "../reducers/TripjackReducer";
const title = ["Mr", "Mrs", "Ms", "Mstr", "Miss"];
const titleC = ["Mstr", "Miss"];
const titleI = ["Mr", "Ms", "Mstr", "Miss"];
const useStyles = makeStyles((theme) => ({
  selectField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #959595",
      },
    },
    backgroundColor: "white",
    marginBottom: 30,
    width: "100%",
    marginTop: 10,
    borderRadius: 5,
    [theme.breakpoints.down("xs")]: {
      marginBottom: 15,
      marginTop: 8,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 5,
    },
    "& .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: 5,
    },
  },
  InputPropsStyle: {
    backgroundColor: "white",
    borderRadius: 5,
  },
  inputPropsStyle: {
    padding: 14,
  },
  createButton: {
    backgroundColor: "rgb(239, 51, 57)",
    color: "white",
    borderRadius: 5,
    width: "100%",
    padding: "11px 8px",
    "&:hover": {
      backgroundColor: "rgb(239, 51, 57)",
    },
  },
  tabBorder: {
    borderBottom: "2px solid transparent",
    color: "#7B95AB",
    fontWeight: 400,
  },
  tabBorderColor: {
    borderBottom: "2px solid #313131",
    color: "#00325B",
    fontWeight: 700,
  },
  tab: {
    [theme.breakpoints.up("sm")]: {
      "& .MuiTab-root": {
        minWidth: 241,
        fontSize: 22,
      },
    },
  },
  date: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 5,
      width: "100%",
    },
  },
  dob: {
    "& .MuiFormControl-root": {
      width: "100%",
    },
  },
  passport: {
    "& .MuiFormControl-root": {
      width: "100%",
    },
  },
  root: {
    "& .MuiFormHelperText-root": {
      fontSize: 12,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: 14,
      padding: "13px 14px",
    },
    "& MuiInputLabel-root": {
      fontSize: 16,
    },
    "& label": {
      fontSize: 15,
    },
  },
  scroll: {
    "&::-webkit-scrollbar": { width: "20px" },
  },
  root2: {
    "& .MuiOutlinedInput-input": {
      fontSize: 14,
      padding: "13px 14px",
    },
    "& MuiInputLabel-root": {
      fontSize: 16,
    },
    "& label": {
      fontSize: 15,
    },
  },
}));
const FlightConfirmForm = ({ value }) => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [state, setState] = React.useState({});
  const [state2, setState2] = React.useState({});
  const [mealprice, setMealr] = useState(0);
  const [hold, setHold] = useState(false);
  const [meal1, setMeal1] = useState("");
  const [child1, setChild1] = React.useState(location.state.child1);
  const [child2, setChild2] = React.useState(location.state.child2);
  const [child3, setChild3] = React.useState(location.state.child3);
  const [child4, setChild4] = React.useState(location.state.child4);
  const [child5, setChild5] = React.useState(location.state.child4);
  const [child6, setChild6] = React.useState(location.state.child4);
  const [infant1, setInfant1] = React.useState(location.state.infant1);
  const [infant2, setInfant2] = React.useState(location.state.infant2);
  const [infant3, setInfant3] = React.useState(location.state.infant3);
  const [infant4, setInfant4] = React.useState(location.state.infant4);
  const [infant5, setInfant5] = React.useState(location.state.infant5);
  const [infant6, setInfant6] = React.useState(location.state.infant6);
  const [age, setAge] = React.useState("");
  const [meal, setMeal] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const handleChangeMeal = (event) => {
    setMeal(event.target.value);
  };
  const { selectedOrigin, selectedDepart } = useSelector((state) => state.ui);
  const [pay, setPay] = useState(false);
  const { agentlogin, travellerlogin } = useSelector((state) => state.user);
  const { farequotetripjack } = useSelector((state) => state.tripjack);
  const [addon, setAddon] = useState(0);
  const { payment, etravflightFare, baggageInfo, mealInfo } = useSelector(
    (state) => state.ui
  );
  const { ssrTBO, loading } = useSelector((state) => state.home);
  const { walletagent } = useSelector((state) => state.user);
  const { fareQuoteEtrav, fareQuote, onewayflightdata } = useSelector(
    (state) => state.home
  );
  const date = new Date();

  const getActualFormat = (given: number) => {
    if (given < 10) {
      return 0 + "" + given.toString();
    } else {
      return given;
    }
  };
  // const handleMeal = (value,index) => {
  //   setMeal(mealprice + value);
  //   setMeal1(1);
  // };
  let BookingFormData = [];
  if (location.state.formData.adult?.length > 0) {
    location.state.formData.adult.map((item) => {
      BookingFormData.push({
        ...item,
        PaxType: 1,
		baggageInfo:{code:"PBAB",
		amount:2250,
		desc:"+ 5 kg Check-in Baggage"}
      });
    });
  }
  if (location.state.formData.child?.length > 0) {
    location.state.formData.child.map((item) => {
      BookingFormData.push({
        ...item,
        PaxType: 2,
      });
    });
  }
  if (location.state.formData.infant?.length > 0) {
    location.state.formData.infant.map((item) => {
      BookingFormData.push({
        ...item,
        PaxType: 3,
      });
    });
  }
  console.log("BookingFormData", BookingFormData);

  console.log("meal", mealprice);
  const invoice = [
    date.getFullYear(),
    getActualFormat(date.getMonth() + 1),
    getActualFormat(date.getDate()),
    getActualFormat(date.getHours()),
    getActualFormat(date.getMinutes()),
    getActualFormat(date.getSeconds()),
  ].join("");
  const [offline, setOffline] = useState(false);
  const [payworldline, setPayWorldline] = useState(false);
  let agentInfo = {
    email:
      agentlogin && agentlogin.status === 200
        ? agentlogin.result.result.email
        : "",
    id:
      agentlogin && agentlogin.status === 200
        ? agentlogin.result.result.id
        : "",
  };
  console.log("state", state);
  console.log("state2", state2);
  let etrav2 = location.state.selectedonward
    ? location.state.selectedonward[0].Airline_Code &&
      location.state.selectedReturn[0].Airline_Code
    : "";
  let etrvotbor = location.state.selectedonward
    ? location.state.selectedonward[0].Airline_Code &&
      location.state.selectedReturn[0].AirlineCode
    : "";
  let etravrtboo = location.state.selectedonward
    ? location.state.selectedReturn[0].Airline_Code &&
      location.state.selectedonward[0].AirlineCode
    : "";
  let tbo2 = location.state.selectedonward
    ? location.state.selectedonward[0].AirlineCode &&
      location.state.selectedReturn[0].AirlineCode
    : "";
  const handlePayment = (response) => {
    if (location.state.OneflightData?.Airline_Code) {
      etravBooking(
        location,
        response,
        invoice,
        dispatch,
        agentInfo,
        fareQuoteEtrav,
        payment,
        FlightBookEtravDispatch,
        history,
        FlightTicketLCCDispatch,
        FlightBookDispatch,
        agentlogin,
        BookingFormData
      );
    } else if (location.state.OneflightData?.IsLCC) {
      tbobooking(
        location,
        response,
        invoice,
        dispatch,
        agentInfo,
        fareQuoteEtrav,
        payment,
        FlightBookEtravDispatch,
        history,
        FlightTicketLCCDispatch,
        FlightBookDispatch,
        agentlogin,
        BookingFormData,
        baggageInfo,
        mealInfo
      );
    } else if (location.state.OneflightData?.IsLCC === false) {
      tbobookingnonlcc(
        location,
        response,
        invoice,
        dispatch,
        agentInfo,
        fareQuoteEtrav,
        payment,
        FlightBookEtravDispatch,
        history,
        FlightTicketLCCDispatch,
        FlightBookDispatch,
        BookingFormData
      );
    } else if (location.state.OneflightData?.Supplier === "TJK") {
      let formDataTJK = {
        bookingId: farequotetripjack.result.bookingId,
        paymentInfos: [
          {
            amount:
              farequotetripjack.result.totalPriceInfo.totalFareDetail.fC.TF,
          },
        ],
        travellerInfo: BookingFormData.map((item, index) => {
          return {
            ti: item.title,
            fN: item.firstname,
            lN: item.lastname,
            pt:
              item.PaxType == 1
                ? "ADULT"
                : item.PaxType == 2
                ? "CHILD"
                : item.PaxType == 3
                ? "INFANT"
                : "",
            dob: item.dob ? item.dob : "1996-04-09",
            pNat: "IN",
            pid: "2021-09-08",
            pNum: item.passportnumber ? item.passportnumber : null,
            eD: item.expiry ? item.expiry : null,
			ssrBaggageInfos:[
				{
					key:item.baggageInfo.amount,
					code:item.baggageInfo.code
				}
			],
          };
        }),
        gstInfo: {
          gstNumber: "18AABCU9603R1ZM",
          email: "apitest2ER@apitest.com ",
          registeredName: "XYZ Pvt Ltd",
          mobile: "+918890005606",
          address: "Dhanbad",
        },
        deliveryInfo: {
          emails: [location.state.formData.email],
          contacts: [location.state.formData.phone],
        },
      };
      dispatch(FlightBookTripJackDispatch(formDataTJK, history));
    }
    if (location.state.selectedonward) {
      if (etrav2) {
        let formEtrav = {
          Customer_Mobile: location.state.formData.phone,
          Passenger_Mobile: location.state.formData.phone,
          orderId: location.state.orderID,
          paymentId:
            response === "success" ? invoice : response.razorpay_payment_id,
          WhatsAPP_Mobile: null,
          Passenger_Email: location.state.formData
            ? location.state.formData.email
            : "",
          PAX_Details: BookingFormData.map((item, index) => {
            return {
              Pax_Id: index + 1,
              Pax_type: item.PaxType - 1,
              Title: item.title,
              First_Name: item.firstname,
              Last_Name: item.lastname,
              Gender: 0,
              Age: null,
              DOB: item.dob ? item.dob : "1998-03-09",
              Passport_Number: item.passportnumber ? item.passportnumber : null,
              Passport_Issuing_Country: null,
              Passport_Expiry: item.expiry ? item.expiry : null,
              Nationality: null,
              FrequentFlyerDetails: null,
            };
          }),

          GST: true,
          GST_Number: "",
          GST_HolderName: "GST Holder Name",
          GST_Address: "GST Address",
          BookingFlightDetails: fareQuoteEtrav.result.AirRepriceResponses.map(
            (item) => {
              return {
                Search_Key: location.state.IDEtrav,
                Flight_Key: item.Flight.Flight_Key,
                BookingSSRDetails: [],
              };
            }
          ),
          CostCenterId: 0,
          ProjectId: 0,
          BookingRemark: `${location.state.returnBody.Segments[0].Origin}-${location.state.returnBody.Segments[0].Destination} ${location.state.returnBody.Segments[0].PreferredDepartureTime} ${invoice}`,
          CorporateStatus: 0,
          CorporatePaymentMode: 0,
          MissedSavingReason: null,
          CorpTripType: null,
          CorpTripSubType: null,
          TripRequestId: null,
          BookingAlertIds: null,
        };
        // console.log("first",formEtrav)
        dispatch(
          FlightBookEtravDispatch(
            formEtrav,
            history,
            payment,
            location.state,
            agentlogin
          )
        );
      } else if (tbo2) {
        if (location.state.selectedonward[0]?.IsLCC) {
          let formDataLCC = {
            TraceId: location.state.IDTBO,
            ResultIndex: location.state.selectedonward[0].ResultIndex,
            orderId: location.state.orderID,
            paymentId:
              response === "success" ? invoice : response.razorpay_payment_id,
            Passengers: BookingFormData.map((item) => {
              return {
                Title: item.title,
                FirstName: item.firstname,
                LastName: item.lastname,
                PaxType: item.PaxType,
                DateOfBirth: item.dob ? item.dob : "1998-03-09",
                Gender: 1,
                PassportNo: item.passportnumber ? item.passportnumber : "",
                PassportExpiry: item.expiry ? item.expiry : "",
                AddressLine1: "hello",
                AddressLine2: "",
                Fare: {
                  Currency: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.Currency
                    : "",
                  BaseFare: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.OfferedFare
                    : "",
                  Tax: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.Tax
                    : "",
                  YQTax: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.YQTax
                    : "",
                  AdditionalTxnFeePub: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.AdditionalTxnFeePub
                    : "",
                  AdditionalTxnFeeOfrd: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.AdditionalTxnFeeOfrd
                    : "",
                  OtherCharges: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.OtherCharges
                    : "",
                  Discount: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.Discount
                    : "",
                  PublishedFare: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.PublishedFare
                    : "",
                  OfferedFare: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.OfferedFare
                    : "",
                  TdsOnCommission: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.TdsOnCommission
                    : "",
                  TdsOnPLB: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.TdsOnPLB
                    : "",
                  TdsOnIncentive: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.TdsOnIncentive
                    : "",
                  ServiceFee: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.ServiceFee
                    : "",
                },
                City: "demo",
                CountryCode: "IN",
                CellCountryCode: "+91",
                ContactNo: location.state.formData
                  ? location.state.formData.phone
                  : "",
                Nationality: "IN",
                Email: location.state.formData
                  ? location.state.formData.email
                  : "",
                IsLeadPax: true,
                FFAirlineCode: null,
                FFNumber: "",
                GSTCompanyAddress: "",
                GSTCompanyContactNumber: "",
                GSTCompanyName: "",
                GSTNumber: "",
                GSTCompanyEmail: "",
              };
            }),
            Baggage: [],
            MealDynamic: [],
            SeatDynamic: [],
          };
          console.log("FormData", formDataLCC);
          dispatch(
            FlightTicketLCCDispatch(
              formDataLCC,
              history,
              location.state,
              agentlogin
            )
          );
        } else if (location.state.selectedonward[0]?.IsLCC === false) {
          let formData = {
            TraceId: location.state.IDTBO,
            ResultIndex: location.state.selectedonward[0].ResultIndex,
            orderId: location.state.orderID,
            paymentId:
              response === "success" ? invoice : response.razorpay_payment_id,
            Passengers: BookingFormData.map((item) => {
              return {
                Title: item.title,
                FirstName: item.firstname,
                LastName: item.lastname,
                PaxType: item.PaxType,
                DateOfBirth: item.dob ? item.dob : "1998-03-09",
                Gender: 1,
                PassportNo: item.passportnumber ? item.passportnumber : "",
                PassportExpiry: item.expiry ? item.expiry : "",
                AddressLine1: "demoaddress",
                AddressLine2: "",
                Fare: {
                  Currency: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.Currency
                    : "",
                  BaseFare: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.OfferedFare
                    : "",
                  Tax: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.Tax
                    : "",
                  YQTax: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.YQTax
                    : "",
                  AdditionalTxnFeePub: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.AdditionalTxnFeePub
                    : "",
                  AdditionalTxnFeeOfrd: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.AdditionalTxnFeeOfrd
                    : "",
                  OtherCharges: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.OtherCharges
                    : "",
                  Discount: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.Discount
                    : "",
                  PublishedFare: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.PublishedFare
                    : "",
                  OfferedFare: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.OfferedFare
                    : "",
                  TdsOnCommission: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.TdsOnCommission
                    : "",
                  TdsOnPLB: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.TdsOnPLB
                    : "",
                  TdsOnIncentive: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.TdsOnIncentive
                    : "",
                  ServiceFee: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.ServiceFee
                    : "",
                },
                City: "demo",
                CountryCode: "IN",
                CellCountryCode: "+91",
                ContactNo: location.state.formData
                  ? location.state.formData.phone
                  : "",
                Nationality: "IN",
                Email: location.state.formData
                  ? location.state.formData.email
                  : "",
                IsLeadPax: true,
                FFAirlineCode: null,
                FFNumber: "",
                GSTCompanyAddress: "",
                GSTCompanyContactNumber: "",
                GSTCompanyName: "",
                GSTNumber: "",
                GSTCompanyEmail: "",
              };
            }),
            Baggage: [],
            MealDynamic: [],
            SeatDynamic: [],
          };
          dispatch(FlightBookDispatch(formData, history, location.state.IDTBO));
        }
        if (location.state.selectedReturn[0]?.IsLCC) {
          let formDataLCC = {
            TraceId: location.state.IDTBO,
            ResultIndex: location.state.selectedReturn[0].ResultIndex,
            orderId: location.state.orderID,
            paymentId:
              response === "success" ? invoice : response.razorpay_payment_id,
            Passengers: BookingFormData.map((item) => {
              return {
                Title: item.title,
                FirstName: item.firstname,
                LastName: item.lastname,
                PaxType: item.PaxType,
                DateOfBirth: item.dob ? item.dob : "1998-03-09",
                Gender: 1,
                PassportNo: item.passportnumber ? item.passportnumber : "",
                PassportExpiry: item.expiry ? item.expiry : "",
                AddressLine1: "demoaddress",
                AddressLine2: "",
                Fare: {
                  Currency: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.Currency
                    : "",
                  BaseFare: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.OfferedFare
                    : "",
                  Tax: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.Tax
                    : "",
                  YQTax: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.YQTax
                    : "",
                  AdditionalTxnFeePub: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.AdditionalTxnFeePub
                    : "",
                  AdditionalTxnFeeOfrd: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.AdditionalTxnFeeOfrd
                    : "",
                  OtherCharges: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.OtherCharges
                    : "",
                  Discount: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.Discount
                    : "",
                  PublishedFare: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.PublishedFare
                    : "",
                  OfferedFare: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.OfferedFare
                    : "",
                  TdsOnCommission: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.TdsOnCommission
                    : "",
                  TdsOnPLB: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.TdsOnPLB
                    : "",
                  TdsOnIncentive: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.TdsOnIncentive
                    : "",
                  ServiceFee: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.ServiceFee
                    : "",
                },
                City: "demo",
                CountryCode: "IN",
                CellCountryCode: "+91",
                ContactNo: location.state.formData
                  ? location.state.formData.phone
                  : "",
                Nationality: "IN",
                Email: location.state.formData
                  ? location.state.formData.email
                  : "",
                IsLeadPax: true,
                FFAirlineCode: null,
                FFNumber: "",
                GSTCompanyAddress: "",
                GSTCompanyContactNumber: "",
                GSTCompanyName: "",
                GSTNumber: "",
                GSTCompanyEmail: "",
              };
            }),
            Baggage: [],
            MealDynamic: [],
            SeatDynamic: [],
          };
          console.log("FormData", formDataLCC);
          dispatch(
            FlightTicketLCCDispatch(
              formDataLCC,
              history,
              location.state,
              agentlogin
            )
          );
        } else if (location.state.selectedReturn[0]?.IsLCC === false) {
          let formData = {
            TraceId: location.state.IDTBO,
            ResultIndex: location.state.selectedReturn[0].ResultIndex,
            orderId: location.state.orderID,
            paymentId:
              response === "success" ? invoice : response.razorpay_payment_id,
            Passengers: BookingFormData.map((item) => {
              return {
                Title: item.title,
                FirstName: item.firstname,
                LastName: item.lastname,
                PaxType: item.PaxType,
                DateOfBirth: item.dob ? item.dob : "1998-03-09",
                Gender: 1,
                PassportNo: item.passportnumber ? item.passportnumber : "",
                PassportExpiry: item.expiry ? item.expiry : "",
                AddressLine1: "demoaddress",
                AddressLine2: "",
                Fare: {
                  Currency: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.Currency
                    : "",
                  BaseFare: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.OfferedFare
                    : "",
                  Tax: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.Tax
                    : "",
                  YQTax: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.YQTax
                    : "",
                  AdditionalTxnFeePub: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.AdditionalTxnFeePub
                    : "",
                  AdditionalTxnFeeOfrd: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.AdditionalTxnFeeOfrd
                    : "",
                  OtherCharges: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.OtherCharges
                    : "",
                  Discount: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.Discount
                    : "",
                  PublishedFare: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.PublishedFare
                    : "",
                  OfferedFare: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.OfferedFare
                    : "",
                  TdsOnCommission: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.TdsOnCommission
                    : "",
                  TdsOnPLB: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.TdsOnPLB
                    : "",
                  TdsOnIncentive: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.TdsOnIncentive
                    : "",
                  ServiceFee: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.ServiceFee
                    : "",
                },
                City: "demo",
                CountryCode: "IN",
                CellCountryCode: "+91",
                ContactNo: location.state.formData
                  ? location.state.formData.phone
                  : "",
                Nationality: "IN",
                Email: location.state.formData
                  ? location.state.formData.email
                  : "",
                IsLeadPax: true,
                FFAirlineCode: null,
                FFNumber: "",
                GSTCompanyAddress: "",
                GSTCompanyContactNumber: "",
                GSTCompanyName: "",
                GSTNumber: "",
                GSTCompanyEmail: "",
              };
            }),
            Baggage: [],
            MealDynamic: [],
            SeatDynamic: [],
          };
          dispatch(FlightBookDispatch(formData, history, location.state.IDTBO));
        }
      } else if (etrvotbor) {
        if (location.state.selectedonward[0]?.Airline_Code) {
          let formEtrav = {
            Customer_Mobile: location.state.formData.phone,
            Passenger_Mobile: location.state.formData.phone,
            orderId: location.state.orderID,
            paymentId:
              response === "success" ? invoice : response.razorpay_payment_id,
            WhatsAPP_Mobile: null,
            Passenger_Email: location.state.formData
              ? location.state.formData.email
              : "",
            PAX_Details: BookingFormData.map((item, index) => {
              return {
                Pax_Id: index + 1,
                Pax_type: item.PaxType - 1,
                Title: item.title,
                First_Name: item.firstname,
                Last_Name: item.lastname,
                Gender: 0,
                Age: null,
                DOB: item.dob ? item.dob : "1998-03-09",
                Passport_Number: item.passportnumber
                  ? item.passportnumber
                  : null,
                Passport_Issuing_Country: null,
                Passport_Expiry: item.expiry ? item.expiry : null,
                Nationality: null,
                FrequentFlyerDetails: null,
              };
            }),

            GST: true,
            GST_Number: "",
            GST_HolderName: "GST Holder Name",
            GST_Address: "GST Address",
            BookingFlightDetails: fareQuoteEtrav.result.AirRepriceResponses.map(
              (item) => {
                return {
                  Search_Key: location.state.IDEtrav,
                  Flight_Key: item.Flight.Flight_Key,
                  BookingSSRDetails: [],
                };
              }
            ),
            CostCenterId: 0,
            ProjectId: 0,
            BookingRemark: `${location.state.returnBody.Segments[0].Origin}-${location.state.returnBody.Segments[0].Destination} ${location.state.returnBody.Segments[0].PreferredDepartureTime} ${invoice}`,
            CorporateStatus: 0,
            CorporatePaymentMode: 0,
            MissedSavingReason: null,
            CorpTripType: null,
            CorpTripSubType: null,
            TripRequestId: null,
            BookingAlertIds: null,
          };
          // console.log("first",formEtrav)
          dispatch(
            FlightBookEtravDispatch(
              formEtrav,
              history,
              payment,
              location.state,
              agentlogin
            )
          );
        }
        if (location.state.selectedReturn[0]?.AirlineCode) {
          if (location.state.selectedReturn[0].IsLCC) {
            console.log("LCC");
            let formDataLCC = {
              TraceId: location.state.IDTBO,
              ResultIndex: location.state.selectedReturn[0].ResultIndex,
              orderId: location.state.orderID,
              paymentId:
                response === "success" ? invoice : response.razorpay_payment_id,
              Passengers: BookingFormData.map((item) => {
                return {
                  Title: item.title,
                  FirstName: item.firstname,
                  LastName: item.lastname,
                  PaxType: item.PaxType,
                  DateOfBirth: item.dob ? item.dob : "1998-03-09",
                  Gender: 1,
                  PassportNo: item.passportnumber ? item.passportnumber : "",
                  PassportExpiry: item.expiry ? item.expiry : "",
                  AddressLine1: "demoaddress",
                  AddressLine2: "",
                  Fare: {
                    Currency: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.Currency
                      : "",
                    BaseFare: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.OfferedFare
                      : "",
                    Tax: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.Tax
                      : "",
                    YQTax: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.YQTax
                      : "",
                    AdditionalTxnFeePub: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare
                          .AdditionalTxnFeePub
                      : "",
                    AdditionalTxnFeeOfrd: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare
                          .AdditionalTxnFeeOfrd
                      : "",
                    OtherCharges: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.OtherCharges
                      : "",
                    Discount: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.Discount
                      : "",
                    PublishedFare: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.PublishedFare
                      : "",
                    OfferedFare: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.OfferedFare
                      : "",
                    TdsOnCommission: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.TdsOnCommission
                      : "",
                    TdsOnPLB: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.TdsOnPLB
                      : "",
                    TdsOnIncentive: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.TdsOnIncentive
                      : "",
                    ServiceFee: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.ServiceFee
                      : "",
                  },
                  City: "",
                  CountryCode: "IN",
                  CellCountryCode: "+91",
                  ContactNo: location.state.formData
                    ? location.state.formData.phone
                    : "",
                  Nationality: "IN",
                  Email: location.state.formData
                    ? location.state.formData.email
                    : "",
                  IsLeadPax: true,
                  FFAirlineCode: null,
                  FFNumber: "",
                  GSTCompanyAddress: "",
                  GSTCompanyContactNumber: "",
                  GSTCompanyName: "",
                  GSTNumber: "",
                  GSTCompanyEmail: "",
                };
              }),
              Baggage: [],
              MealDynamic: [],
              SeatDynamic: [],
            };
            console.log("FormData", formDataLCC);
            dispatch(
              FlightTicketLCCDispatch(
                formDataLCC,
                history,
                location.state,
                agentlogin
              )
            );
          } else if (location.state.selectedReturn[0].IsLCC === false) {
            console.log("ISlcc");
            let formData = {
              TraceId: location.state.IDTBO,
              ResultIndex: location.state.selectedReturn[0].ResultIndex,
              orderId: location.state.orderID,
              paymentId:
                response === "success" ? invoice : response.razorpay_payment_id,
              Passengers: BookingFormData.map((item) => {
                return {
                  Title: item.title,
                  FirstName: item.firstname,
                  LastName: item.lastname,
                  PaxType: item.PaxType,
                  DateOfBirth: item.dob ? item.dob : "1998-03-09",
                  Gender: 1,
                  PassportNo: item.passportnumber ? item.passportnumber : "",
                  PassportExpiry: item.expiry ? item.expiry : "",
                  AddressLine1: "demoaddress",
                  AddressLine2: "",
                  Fare: {
                    Currency: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.Currency
                      : "",
                    BaseFare: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.OfferedFare
                      : "",
                    Tax: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.Tax
                      : "",
                    YQTax: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.YQTax
                      : "",
                    AdditionalTxnFeePub: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare
                          .AdditionalTxnFeePub
                      : "",
                    AdditionalTxnFeeOfrd: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare
                          .AdditionalTxnFeeOfrd
                      : "",
                    OtherCharges: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.OtherCharges
                      : "",
                    Discount: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.Discount
                      : "",
                    PublishedFare: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.PublishedFare
                      : "",
                    OfferedFare: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.OfferedFare
                      : "",
                    TdsOnCommission: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.TdsOnCommission
                      : "",
                    TdsOnPLB: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.TdsOnPLB
                      : "",
                    TdsOnIncentive: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.TdsOnIncentive
                      : "",
                    ServiceFee: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.ServiceFee
                      : "",
                  },
                  City: "demo",
                  CountryCode: "IN",
                  CellCountryCode: "+91",
                  ContactNo: location.state.formData
                    ? location.state.formData.phone
                    : "",
                  Nationality: "IN",
                  Email: location.state.formData
                    ? location.state.formData.email
                    : "",
                  IsLeadPax: true,
                  FFAirlineCode: null,
                  FFNumber: "",
                  GSTCompanyAddress: "",
                  GSTCompanyContactNumber: "",
                  GSTCompanyName: "",
                  GSTNumber: "",
                  GSTCompanyEmail: "",
                };
              }),
              Baggage: [],
              MealDynamic: [],
              SeatDynamic: [],
            };
            dispatch(
              FlightBookDispatch(formData, history, location.state.IDTBO)
            );
          }
        }
      } else if (etravrtboo) {
        if (location.state.selectedReturn[0]?.Airline_Code) {
          let formEtrav = {
            Customer_Mobile: location.state.formData.phone,
            Passenger_Mobile: location.state.formData.phone,
            orderId: location.state.orderID,
            paymentId:
              response === "success" ? invoice : response.razorpay_payment_id,
            WhatsAPP_Mobile: null,
            Passenger_Email: location.state.formData
              ? location.state.formData.email
              : "",
            PAX_Details: BookingFormData.map((item, index) => {
              return {
                Pax_Id: index + 1,
                Pax_type: item.PaxType - 1,
                Title: item.title,
                First_Name: item.firstname,
                Last_Name: item.lastname,
                Gender: 0,
                Age: null,
                DOB: item.dob ? item.dob : "1998-03-09",
                Passport_Number: item.passportnumber
                  ? item.passportnumber
                  : null,
                Passport_Issuing_Country: null,
                Passport_Expiry: item.expiry ? item.expiry : null,
                Nationality: null,
                FrequentFlyerDetails: null,
              };
            }),

            GST: true,
            GST_Number: "",
            GST_HolderName: "GST Holder Name",
            GST_Address: "GST Address",
            BookingFlightDetails: fareQuoteEtrav.result.AirRepriceResponses.map(
              (item) => {
                return {
                  Search_Key: location.state.IDEtrav,
                  Flight_Key: item.Flight.Flight_Key,
                  BookingSSRDetails: [],
                };
              }
            ),
            CostCenterId: 0,
            ProjectId: 0,
            BookingRemark: `${location.state.returnBody.Segments[0].Origin}-${location.state.returnBody.Segments[0].Destination} ${location.state.returnBody.Segments[0].PreferredDepartureTime} ${invoice}`,
            CorporateStatus: 0,
            CorporatePaymentMode: 0,
            MissedSavingReason: null,
            CorpTripType: null,
            CorpTripSubType: null,
            TripRequestId: null,
            BookingAlertIds: null,
          };
          // console.log("first",formEtrav)
          dispatch(
            FlightBookEtravDispatch(
              formEtrav,
              history,
              payment,
              location.state,
              agentlogin
            )
          );
        }
        if (location.state.selectedonward[0]?.AirlineCode) {
          if (location.state.selectedonward[0].IsLCC) {
            console.log("LCC");
            let formDataLCC = {
              TraceId: location.state.IDTBO,
              ResultIndex: location.state.selectedonward[0].ResultIndex,
              orderId: location.state.orderID,
              paymentId:
                response === "success" ? invoice : response.razorpay_payment_id,
              Passengers: BookingFormData.map((item) => {
                return {
                  Title: item.title,
                  FirstName: item.firstname,
                  LastName: item.lastname,
                  PaxType: item.PaxType,
                  DateOfBirth: item.dob ? item.dob : "1998-03-09",
                  Gender: 1,
                  PassportNo: item.passportnumber ? item.passportnumber : "",
                  PassportExpiry: item.expiry ? item.expiry : "",
                  AddressLine1: "demoaddress",
                  AddressLine2: "",
                  Fare: {
                    Currency: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.Currency
                      : "",
                    BaseFare: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.OfferedFare
                      : "",
                    Tax: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.Tax
                      : "",
                    YQTax: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.YQTax
                      : "",
                    AdditionalTxnFeePub: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare
                          .AdditionalTxnFeePub
                      : "",
                    AdditionalTxnFeeOfrd: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare
                          .AdditionalTxnFeeOfrd
                      : "",
                    OtherCharges: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.OtherCharges
                      : "",
                    Discount: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.Discount
                      : "",
                    PublishedFare: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.PublishedFare
                      : "",
                    OfferedFare: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.OfferedFare
                      : "",
                    TdsOnCommission: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.TdsOnCommission
                      : "",
                    TdsOnPLB: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.TdsOnPLB
                      : "",
                    TdsOnIncentive: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.TdsOnIncentive
                      : "",
                    ServiceFee: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.ServiceFee
                      : "",
                  },
                  City: "demo",
                  CountryCode: "IN",
                  CellCountryCode: "+91",
                  ContactNo: location.state.formData
                    ? location.state.formData.phone
                    : "",
                  Nationality: "IN",
                  Email: location.state.formData
                    ? location.state.formData.email
                    : "",
                  IsLeadPax: true,
                  FFAirlineCode: null,
                  FFNumber: "",
                  GSTCompanyAddress: "",
                  GSTCompanyContactNumber: "",
                  GSTCompanyName: "",
                  GSTNumber: "",
                  GSTCompanyEmail: "",
                };
              }),
              Baggage: [],
              MealDynamic: [],
              SeatDynamic: [],
            };
            console.log("FormData", formDataLCC);
            dispatch(
              FlightTicketLCCDispatch(
                formDataLCC,
                history,
                location.state,
                agentlogin
              )
            );
          } else if (location.state.selectedonward[0]?.IsLCC === false) {
            let formData = {
              TraceId: location.state.IDTBO,
              ResultIndex: location.state.selectedonward[0].ResultIndex,
              orderId: location.state.orderID,
              paymentId:
                response === "success" ? invoice : response.razorpay_payment_id,
              Passengers: BookingFormData.map((item) => {
                return {
                  Title: item.title,
                  FirstName: item.firstname,
                  LastName: item.lastname,
                  PaxType: item.PaxType,
                  DateOfBirth: item.dob ? item.dob : "1998-03-09",
                  Gender: 1,
                  PassportNo: item.passportnumber ? item.passportnumber : "",
                  PassportExpiry: item.expiry ? item.expiry : "",
                  AddressLine1: "demoaddress",
                  AddressLine2: "",
                  Fare: {
                    Currency: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.Currency
                      : "",
                    BaseFare: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.OfferedFare
                      : "",
                    Tax: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.Tax
                      : "",
                    YQTax: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.YQTax
                      : "",
                    AdditionalTxnFeePub: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare
                          .AdditionalTxnFeePub
                      : "",
                    AdditionalTxnFeeOfrd: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare
                          .AdditionalTxnFeeOfrd
                      : "",
                    OtherCharges: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.OtherCharges
                      : "",
                    Discount: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.Discount
                      : "",
                    PublishedFare: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.PublishedFare
                      : "",
                    OfferedFare: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.OfferedFare
                      : "",
                    TdsOnCommission: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.TdsOnCommission
                      : "",
                    TdsOnPLB: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.TdsOnPLB
                      : "",
                    TdsOnIncentive: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.TdsOnIncentive
                      : "",
                    ServiceFee: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.ServiceFee
                      : "",
                  },
                  City: "demo",
                  CountryCode: "IN",
                  CellCountryCode: "+91",
                  ContactNo: location.state.formData
                    ? location.state.formData.phone
                    : "",
                  Nationality: "IN",
                  Email: location.state.formData
                    ? location.state.formData.email
                    : "",
                  IsLeadPax: true,
                  FFAirlineCode: null,
                  FFNumber: "",
                  GSTCompanyAddress: "",
                  GSTCompanyContactNumber: "",
                  GSTCompanyName: "",
                  GSTNumber: "",
                  GSTCompanyEmail: "",
                };
              }),
              Baggage: [],
              MealDynamic: [],
              SeatDynamic: [],
            };
            dispatch(
              FlightBookDispatch(formData, history, location.state.IDTBO)
            );
          }
        }
      } else if (
        location.state.selectedonward[0]?.Supplier === "TJK" &&
        location.state.selectedReturn[0]?.Supplier === "TJK"
      ) {
        let formDataTJK = {
          bookingId: farequotetripjack.result.bookingId,
          paymentInfos: [
            {
              amount:
                farequotetripjack.result.totalPriceInfo.totalFareDetail.fC.TF,
            },
          ],
          travellerInfo: BookingFormData.map((item, index) => {
            return {
              ti: item.title,
              fN: item.firstname,
              lN: item.lastname,
              pt:
                item.PaxType == 1
                  ? "ADULT"
                  : item.PaxType == 2
                  ? "CHILD"
                  : item.PaxType == 3
                  ? "INFANT"
                  : "",
              dob: item.dob ? item.dob : "1996-04-09",
              pNat: "IN",
              pid: "2021-09-08",
              pNum: item.passportnumber ? item.passportnumber : null,
              eD: item.expiry ? item.expiry : null,
            };
          }),
          gstInfo: {
            gstNumber: "18AABCU9603R1ZM",
            email: "apitest2ER@apitest.com ",
            registeredName: "XYZ Pvt Ltd",
            mobile: "+918890005606",
            address: "Dhanbad",
          },
          deliveryInfo: {
            emails: [location.state.formData.email],
            contacts: [location.state.formData.phone],
          },
        };
        dispatch(FlightBookTripJackDispatch(formDataTJK, history));
      }
    }
    if (location.state.intFlight) {
      console.log("first");
      if (location.state.intFlight.IsLCC) {
        console.log("LCC");
        let formDataLCC = {
          TraceId: location.state.IDTBO,
          ResultIndex: location.state.intFlight.ResultIndex,
          orderId: location.state.orderID,
          paymentId:
            response === "success" ? invoice : response.razorpay_payment_id,
          Passengers: BookingFormData.map((item) => {
            return {
              Title: item.title,
              FirstName: item.firstname,
              LastName: item.lastname,
              PaxType: item.PaxType,
              DateOfBirth: item.dob ? item.dob : "1998-03-09",
              Gender: 1,
              PassportNo: item.passportnumber ? item.passportnumber : "",
              PassportExpiry: item.expiry ? item.expiry : "",
              AddressLine1: "demoaddress",
              AddressLine2: "",
              Fare: {
                Currency: location.state.intFlight
                  ? location.state.intFlight.Fare.Currency
                  : "",
                BaseFare: location.state.intFlight
                  ? location.state.intFlight.Fare.OfferedFare
                  : "",
                Tax: location.state.intFlight
                  ? location.state.intFlight.Fare.Tax
                  : "",
                YQTax: location.state.intFlight
                  ? location.state.intFlight.Fare.YQTax
                  : "",
                AdditionalTxnFeePub: location.state.intFlight
                  ? location.state.intFlight.Fare.AdditionalTxnFeePub
                  : "",
                AdditionalTxnFeeOfrd: location.state.intFlight
                  ? location.state.intFlight.Fare.AdditionalTxnFeeOfrd
                  : "",
                OtherCharges: location.state.intFlight
                  ? location.state.intFlight.Fare.OtherCharges
                  : "",
                Discount: location.state.intFlight
                  ? location.state.intFlight.Fare.Discount
                  : "",
                PublishedFare: location.state.intFlight
                  ? location.state.intFlight.Fare.PublishedFare
                  : "",
                OfferedFare: location.state.intFlight
                  ? location.state.intFlight.Fare.OfferedFare
                  : "",
                TdsOnCommission: location.state.intFlight
                  ? location.state.intFlight.Fare.TdsOnCommission
                  : "",
                TdsOnPLB: location.state.intFlight
                  ? location.state.intFlight.Fare.TdsOnPLB
                  : "",
                TdsOnIncentive: location.state.intFlight
                  ? location.state.intFlight.Fare.TdsOnIncentive
                  : "",
                ServiceFee: location.state.intFlight
                  ? location.state.intFlight.Fare.ServiceFee
                  : "",
              },
              City: "",
              CountryCode: "IN",
              CellCountryCode: "+91",
              ContactNo: location.state.formData
                ? location.state.formData.phone
                : "",
              Nationality: "IN",
              Email: location.state.formData
                ? location.state.formData.email
                : "",
              IsLeadPax: true,
              FFAirlineCode: null,
              FFNumber: "",
              GSTCompanyAddress: "",
              GSTCompanyContactNumber: "",
              GSTCompanyName: "",
              GSTNumber: "",
              GSTCompanyEmail: "",
            };
          }),
          Baggage: [],
          MealDynamic: [],
          SeatDynamic: [],
        };
        console.log("FormData", formDataLCC);
        dispatch(
          FlightTicketLCCDispatch(
            formDataLCC,
            history,
            location.state,
            agentlogin
          )
        );
      } else if (location.state.intFlight.IsLCC === false) {
        let formData = {
          TraceId: location.state.IDTBO,
          ResultIndex: location.state.intFlight.ResultIndex,
          orderId: location.state.orderID,
          paymentId:
            response === "success" ? invoice : response.razorpay_payment_id,
          Passengers: BookingFormData.map((item) => {
            return {
              Title: item.title,
              FirstName: item.firstname,
              LastName: item.lastname,
              PaxType: item.PaxType,
              DateOfBirth: item.dob ? item.dob : "1998-03-09",
              Gender: 1,
              PassportNo: item.passportnumber ? item.passportnumber : "",
              PassportExpiry: item.expiry ? item.expiry : "",
              AddressLine1: "demoaddress",
              AddressLine2: "",
              Fare: {
                Currency: location.state.intFlight
                  ? location.state.intFlight.Fare.Currency
                  : "",
                BaseFare: location.state.intFlight
                  ? location.state.intFlight.Fare.OfferedFare
                  : "",
                Tax: location.state.intFlight
                  ? location.state.intFlight.Fare.Tax
                  : "",
                YQTax: location.state.intFlight
                  ? location.state.intFlight.Fare.YQTax
                  : "",
                AdditionalTxnFeePub: location.state.intFlight
                  ? location.state.intFlight.Fare.AdditionalTxnFeePub
                  : "",
                AdditionalTxnFeeOfrd: location.state.intFlight
                  ? location.state.intFlight.Fare.AdditionalTxnFeeOfrd
                  : "",
                OtherCharges: location.state.intFlight
                  ? location.state.intFlight.Fare.OtherCharges
                  : "",
                Discount: location.state.intFlight
                  ? location.state.intFlight.Fare.Discount
                  : "",
                PublishedFare: location.state.intFlight
                  ? location.state.intFlight.Fare.PublishedFare
                  : "",
                OfferedFare: location.state.intFlight
                  ? location.state.intFlight.Fare.OfferedFare
                  : "",
                TdsOnCommission: location.state.intFlight
                  ? location.state.intFlight.Fare.TdsOnCommission
                  : "",
                TdsOnPLB: location.state.intFlight
                  ? location.state.intFlight.Fare.TdsOnPLB
                  : "",
                TdsOnIncentive: location.state.intFlight
                  ? location.state.intFlight.Fare.TdsOnIncentive
                  : "",
                ServiceFee: location.state.intFlight
                  ? location.state.intFlight.Fare.ServiceFee
                  : "",
              },
              City: "",
              CountryCode: "IN",
              CellCountryCode: "+91",
              ContactNo: location.state.formData
                ? location.state.formData.phone
                : "",
              Nationality: "IN",
              Email: location.state.formData
                ? location.state.formData.email
                : "",
              IsLeadPax: true,
              FFAirlineCode: null,
              FFNumber: "",
              GSTCompanyAddress: "",
              GSTCompanyContactNumber: "",
              GSTCompanyName: "",
              GSTNumber: "",
              GSTCompanyEmail: "",
            };
          }),
          Baggage: [],
          MealDynamic: [],
          SeatDynamic: [],
        };
        dispatch(FlightBookDispatch(formData, history, location.state.IDTBO));
      }
    }
  };
  const PGCharge = 200;
  const handleFormSubmit = (data) => {
    const selectedFlight = location.state.OneflightData;
    const priceDetails = fareQuoteEtrav
      ? fareQuoteEtrav.result?.AirRepriceResponses[0].Flight
      : fareQuote
      ? fareQuote.result?.Response.Results
      : "";
    const priceDetails2 = fareQuoteEtrav
      ? fareQuoteEtrav?.result?.AirRepriceResponses[0]?.Flight
      : "";
    const priceDetails3 = fareQuote ? fareQuote.result.Response.Results : "";
    const payableAmout = location.state.OneflightData
      ? location.state.OneflightData?.Supplier === "ETR"
        ? Number(
            Math.round(location.state.OneflightData?.Fares?.Total_Amount)
          ) -
          Number(Math.round(location.state.OneflightData?.Fares?.agentMarkup)) +
          Number(
            (Number(
              Number(
                Math.round(location.state.OneflightData?.Fares?.Total_Amount)
              ) -
                Number(
                  Math.round(location.state.OneflightData?.Fares?.agentMarkup)
                )
            ) *
              2.5) /
              100
          )+Number(Math.round(baggageInfo[0]?.AirlineCode?baggageInfo[0]?.Price:baggageInfo[0]?.code?baggageInfo[0]?.amount:0))+Number(Math.round(mealInfo[0]?.AirlineCode?mealInfo[0]?.Price:mealInfo[0]?.code?mealInfo[0]?.amount:0))
        : location.state.OneflightData?.Supplier === "TBO"
        ? Number(Math.round(location.state.OneflightData?.Fare?.Total_Amount)) -
          Number(Math.round(location.state.OneflightData?.Fare?.agentMarkup)) +
          Number(
            (Number(
              Number(
                Math.round(location.state.OneflightData?.Fare?.Total_Amount)
              ) -
                Number(
                  Math.round(location.state.OneflightData?.Fare?.agentMarkup)
                )
            ) *
              2.5) /
              100
          )+Number(Math.round(baggageInfo[0]?.AirlineCode?baggageInfo[0]?.Price:baggageInfo[0]?.code?baggageInfo[0]?.amount:0))+Number(Math.round(mealInfo[0]?.AirlineCode?mealInfo[0]?.Price:mealInfo[0]?.code?mealInfo[0]?.amount:0))
        : location.state.OneflightData?.Supplier === "TJK"
        ? Number(
            Math.round(
              location.state.OneflightData?.totalPriceList?.fd.Total_Amount
            )
          ) -
          Number(
            Math.round(
              location.state.OneflightData?.totalPriceList?.fd.agentMarkup
            )
          ) +
          Number(
            (Number(
              Number(
                Math.round(
                  location.state.OneflightData?.totalPriceList?.fd.Total_Amount
                )
              ) -
                Number(
                  Math.round(
                    location.state.OneflightData?.totalPriceList?.fd.agentMarkup
                  )
                )
            ) *
              2.5) /
              100
          )+Number(Math.round(baggageInfo[0]?.AirlineCode?baggageInfo[0]?.Price:baggageInfo[0]?.code?baggageInfo[0]?.amount:0))+Number(Math.round(mealInfo[0]?.AirlineCode?mealInfo[0]?.Price:mealInfo[0]?.code?mealInfo[0]?.amount:0))
        : ""
      : location.state.intFlight?.Supplier === "TBO"
      ? Number(Math.round(location.state.intFlight.Fare.Total_Amount)) -
        Number(Math.round(location.state.intFlight.Fare.agentMarkup)) +
        Number(
          (Number(
            Number(Math.round(location.state.intFlight.Fare.Total_Amount)) -
              Number(Math.round(location.state.intFlight.Fare.agentMarkup))
          ) *
            2.5) /
            100
        )
      : Number(
          Number(
            Math.round(
              location.state.selectedonward[0].Airline_Code
                ? location.state.selectedonward[0].Fares.Total_Amount
                : location.state.selectedonward[0].AirlineCode
                ? location.state.selectedonward[0].Fare.Total_Amount
                : 0
            )
          ) +
            Number(
              Math.round(
                location.state.selectedReturn[0].Airline_Code
                  ? location.state.selectedReturn[0].Fares.Total_Amount
                  : location.state.selectedonward[0].AirlineCode
                  ? location.state.selectedReturn[0].Fare.Total_Amount
                  : 0
              ) -
                Number(
                  Math.round(
                    location.state.selectedReturn[0].Airline_Code
                      ? 0
                      : location.state.selectedonward[0].AirlineCode
                      ? location.state.selectedReturn[0].Fare.MFB_Discount
                      : 0
                  )
                ) -
                Number(
                  Math.round(
                    location.state.selectedonward[0].Airline_Code
                      ? 0
                      : location.state.selectedonward[0].AirlineCode
                      ? location.state.selectedonward[0].Fare.MFB_Discount
                      : 0
                  )
                )
            ) +
            (Number(
              Number(
                Math.round(
                  location.state.selectedonward[0].Airline_Code
                    ? location.state.selectedonward[0].Fares.Total_Amount
                    : location.state.selectedonward[0].AirlineCode
                    ? location.state.selectedonward[0].Fare.Total_Amount
                    : 0
                )
              ) +
                Number(
                  Math.round(
                    location.state.selectedReturn[0].Airline_Code
                      ? location.state.selectedReturn[0].Fares.Total_Amount
                      : location.state.selectedonward[0].AirlineCode
                      ? location.state.selectedReturn[0].Fare.Total_Amount
                      : 0
                  )
                ) -
                Number(
                  Math.round(
                    location.state.selectedReturn[0].Airline_Code
                      ? 0
                      : location.state.selectedonward[0].AirlineCode
                      ? location.state.selectedReturn[0].Fare.MFB_Discount
                      : 0
                  )
                ) -
                Number(
                  Math.round(
                    location.state.selectedonward[0].Airline_Code
                      ? 0
                      : location.state.selectedonward[0].AirlineCode
                      ? location.state.selectedonward[0].Fare.MFB_Discount
                      : 0
                  )
                )
            ) *
              2.5) /
              100
        );

    if (location.state.selectedonward) {
      addBookingReturn(
        location,
        agentlogin,
        payment,
        payableAmout,
        priceDetails2,
        priceDetails3,
        selectedFlight,
        dispatch,
        FlightAddBookingDispatch,
        PGCharge,
        BookingFormData
      );
    } else if (
      location.state.OneflightData.Supplier === "ETR" ||
      location.state.OneflightData.Supplier === "TBO"
    ) {
      addBooking(
        location,
        agentlogin,
        payment,
        payableAmout,
        priceDetails,
        selectedFlight,
        dispatch,
        FlightAddBookingDispatch,
        PGCharge,
        BookingFormData
      );
    } else if (location.state.intFlight) {
      console.log("Inflight");
      addINtBooking(
        location,
        agentlogin,
        payment,
        payableAmout,
        priceDetails,
        selectedFlight,
        dispatch,
        FlightAddBookingDispatch,
        PGCharge,
        BookingFormData
      );
      // addBooking(

      // );
    } else if (location.state.OneflightData.Supplier === "TJK") {
    }

    if (payment === "pay") {
      // e.preventDefault();
      var options = {
        key: "rzp_test_1xufv8E9EKecYL",
        key_secret: "Ui7h6GeBLYxy1y75QaV6TgBz",
        // key: "rzp_live_IZ3H2uQBdbxAbv",
        // key_secret: "JVXsfYLHnTU4xk8uRGvmwZ2Q",
        amount: Number(Math.round(payableAmout)) * 100,

        currency: "INR",
        name: "Musafir Bazar",
        description: "for testing purpose",
        handler: handlePayment,
        prefill: {
          name: `${location.state.formData.first_name} ${location.state.formData.last_name}`,
          email: location.state.formData.email,
          contact: location.state.formData.phone,
        },
        notes: {
          address: location.state.formData.address,
        },
        theme: {
          color: "#3399cc",
        },
      };
      var pay = new window.Razorpay(options);
      pay.open();
    } else if (payment === "offline") {
      let res = "success";
      handlePayment(res);
    } else if (payment === "payworldline") {
      dispatch(togglePGModal(true));
    }
  };
  const handleHold = (e) => {
    if (e.target.value === "payworldline") {
      dispatch(setPayment(e.target.value));
      if (payworldline) {
        setPay(false);
        setOffline(false);
        setPayWorldline(false);
      } else {
        setPayWorldline(true);
        setPay(false);
        setOffline(false);
      }
    } else if (e.target.value === "pay") {
      dispatch(setPayment(e.target.value));
      if (pay) {
        setPay(false);
        setOffline(false);
        setPayWorldline(false);
      } else {
        setPay(true);
        setPayWorldline(false);
        setOffline(false);
      }
    } else if (e.target.value === "offline") {
      dispatch(setPayment(e.target.value));
      if (offline) {
        setPay(false);
        setPayWorldline(false);
        setOffline(false);
      } else {
        setPay(false);
        setPayWorldline(false);
        setOffline(true);
      }
    }

    console.log(e.target.value);
  };
  const edit = () => {
    history.push({
      pathname: "/summaryflight",
      state: {
        formData: location.state.formData,
        body: location.state.body,
        OneflightData: location.state.OneflightData,
      },
    });
  };
  const adult = location.state.body
    ? location.state.body.AdultCount
    : location.state.returnBody.AdultCount;
  const child = location.state.body
    ? location.state.body.ChildCount
    : location.state.returnBody.ChildCount;
  const infant = location.state.body
    ? location.state.body.InfantCount
    : location.state.returnBody.InfantCount;
  const ar = [];
  const ar2 = [];
  const ar3 = [];
  for (let i = 1; i <= adult; i++) {
    ar.push({});
  }
  for (let i = 1; i <= child; i++) {
    ar2.push({});
  }
  for (let i = 1; i <= infant; i++) {
    ar3.push({});
  }
  return (
    <>
      <Formik
        initialValues={{
          adults: location.state.formData.adult,
          childs: location.state.formData.child,
          infants: location.state.formData.infant,
        }}
        onSubmit={handleFormSubmit}
      >
        {(formik) => (
          <Form>
            <Box
              className={classes.root}
              style={{
                background: "white",
                padding: "10px 15px",
                border: "1px solid #e6e6e6",
                marginTop: "10px",
                boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                borderRadius: "5px",
              }}
            >
              <Grid
                container
                spacing={2}
                alignItems="center"
                style={{ marginTop: 20, alignItems: "baseline" }}
              >
                <Grid item xs={12} lg={6}>
                  <Field
                    component={TextField}
                    name="email"
                    type="email"
                    disabled
                    variant="outlined"
                    value={location.state.formData.email}
                    // error={errors.email}
                    // label='Email ID'
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 12 },
                    }}
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <Field
                    component={TextField}
                    name="phone"
                    disabled
                    type="number"
                    value={location.state.formData.phone}
                    variant="outlined"
                    // error={errors.phone}
                    // label='Mobile No.'
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 12 },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
            <FieldArray
              name="adult"
              render={(arrayHelpers) => {
                return (
                  <div>
                    {formik.values.adults.map((adult, index) => (
                      <>
                        <Box
                          className={classes.root}
                          style={{
                            background: "white",
                            padding: "10px 15px",
                            border: "1px solid #e6e6e6",
                            marginTop: "10px",
                            boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                            borderRadius: "5px",
                          }}
                        >
                          <div>{`Enter the Detail of Adult.${index + 1}`}</div>
                         
                          <Grid
                            container
                            spacing={2}
                            alignItems="center"
                            style={{ marginTop: 20, alignItems: "baseline" }}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              lg={4}
                              className={classes.root2}
                              style={{ alignItems: "center" }}
                            >
                              <Field
                                component={TextField}
                                select
                                disabled
                                name={`adult.${index}.title`}
                                type="text"
                                variant="outlined"
                                // label='Select Title'
                                value={adult.title}
                                // error={errors.titleA1}
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  className: classes.inputPropsStyle,
                                }}
                              >
                                {title.map((item, index) => (
                                  <MenuItem key={index} value={item}>
                                    {item}
                                  </MenuItem>
                                ))}
                              </Field>
                            </Grid>
                            <Grid item xs={12} sm={6} lg={4}>
                              <Field
                                component={TextField}
                                name={`adult.${index}.firstname`}
                                type="text"
                                disabled
                                // error={errors.first_nameA1}
                                variant="outlined"
                                value={adult.firstname}
                                // label='Enter First Name'
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={4}>
                              <Field
                                component={TextField}
                                name={`adult.${index}.lastname`}
                                type="text"
                                disabled
                                value={adult.lastname}
                                // error={errors.last_nameA1}
                                variant="outlined"
                                // label='Enter Last Name'
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            {selectedOrigin.country_code === "IN" &&
                            selectedDepart.country_code === "IN" ? (
                              ""
                            ) : (
                              <>
                                <Grid item xs={12} sm={6} lg={4}>
                                  <Field
                                    component={TextField}
                                    name={`adult.${index}.passportnumber`}
                                    type="text"
                                    disabled
                                    value={adult.passportnumber}
                                    // error={errors.last_nameA1}
                                    variant="outlined"
                                    // label="Enter Passport Number"
                                    className={classes.selectField}
                                    InputProps={{
                                      className: classes.InputPropsStyle,
                                    }}
                                    inputProps={{
                                      style: { padding: 12 },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={4}>
                                  <Field
                                    component={TextField}
                                    name={`adult.${index}.expiry`}
                                    type="date"
                                    disabled
                                    // error={errors.last_nameA1}
                                    variant="outlined"
                                    value={adult.expiry}
                                    // label='Enter Passport Number'
                                    className={classes.selectField}
                                    InputProps={{
                                      className: classes.InputPropsStyle,
                                    }}
                                    inputProps={{
                                      style: { padding: 12 },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={4}>
                                  <Field
                                    component={TextField}
                                    name={`adult.${index}.dob`}
                                    type="date"
                                    disabled
                                    value={adult.dob}
                                    // error={errors.last_nameA1}
                                    variant="outlined"
                                    // label='Enter Passport Number'
                                    className={classes.selectField}
                                    InputProps={{
                                      className: classes.InputPropsStyle,
                                    }}
                                    inputProps={{
                                      style: { padding: 12 },
                                    }}
                                  />
                                </Grid>
                              </>
                            )}
                          </Grid>
                        </Box>
                      </>
                    ))}
                    {/* <div onClick={() => arrayHelpers.insert()}>
											<h2>Add</h2>
										</div> */}
                  </div>
                );
              }}
            />
            <FieldArray
              name="child"
              render={(arrayHelpers) => {
                return (
                  <div>
                    {formik.values.childs?.map((child, index) => (
                      <>
                        <Box
                          className={classes.root}
                          style={{
                            background: "white",
                            padding: "10px 15px",
                            border: "1px solid #e6e6e6",
                            marginTop: "10px",
                            boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                            borderRadius: "5px",
                          }}
                        >
                          <div>{`Enter the Detail of Child.${index + 1}`}</div>
                          {/* <Field
														disabled
														type='text'
														name={`chil.${index}.firsName`}
														value={chil.firsName}
													/>
													<Field type='date' name={`chil.${index}.date`} /> */}
                          <Grid
                            container
                            spacing={2}
                            alignItems="center"
                            style={{ marginTop: 20, alignItems: "baseline" }}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              lg={3}
                              className={classes.root2}
                              style={{ alignItems: "center" }}
                            >
                              <Field
                                component={TextField}
                                select
                                name={`child.${index}.title`}
                                type="text"
                                value={child.title}
                                variant="outlined"
                                disabled
                                // label='Select Title'
                                // error={errors.titleC1}
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  className: classes.inputPropsStyle,
                                }}
                              >
                                {titleC.map((item, index) => (
                                  <MenuItem key={index} value={item}>
                                    {item}
                                  </MenuItem>
                                ))}
                              </Field>
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                              <Field
                                component={TextField}
                                name={`child.${index}.firstname`}
                                type="text"
                                value={child.firstname}
                                variant="outlined"
                                disabled
                                // error={errors.first_nameC1}
                                // label='Enter First Name'
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                              <Field
                                component={TextField}
                                name={`child.${index}.lastname`}
                                type="text"
                                value={child.lastname}
                                variant="outlined"
                                disabled
                                // error={errors.last_nameC1}
                                // label='Enter Last Name'
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                              <Field
                                component={TextField}
                                name={`child.${index}.dob`}
                                type="date"
                                value={child.dob}
                                variant="outlined"
                                disabled
                                // error={errors.last_nameC1}
                                // label='Enter Last Name'
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            {selectedOrigin.country_code === "IN" &&
                            selectedDepart.country_code === "IN" ? (
                              ""
                            ) : (
                              <>
                                <Grid item xs={12} sm={6} lg={4}>
                                  <Field
                                    component={TextField}
                                    name={`child.${index}.passportnumber`}
                                    type="text"
                                    // error={errors.last_nameA1}
                                    variant="outlined"
                                    disabled
                                    value={child.passportnumber}
                                    // label="Enter Passport Number"
                                    className={classes.selectField}
                                    InputProps={{
                                      className: classes.InputPropsStyle,
                                    }}
                                    inputProps={{
                                      style: { padding: 12 },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={4}>
                                  <Field
                                    component={TextField}
                                    name={`child.${index}.expiry`}
                                    type="date"
                                    disabled
                                    value={child.expiry}
                                    // error={errors.last_nameA1}
                                    variant="outlined"
                                    // label='Enter Passport Number'
                                    className={classes.selectField}
                                    InputProps={{
                                      className: classes.InputPropsStyle,
                                    }}
                                    inputProps={{
                                      style: { padding: 12 },
                                    }}
                                  />
                                </Grid>
                              </>
                            )}
                          </Grid>
                        </Box>
                      </>
                    ))}
                  </div>
                );
              }}
            />
            <FieldArray
              name="infant"
              render={(arrayHelpers) => {
                return (
                  <div>
                    {formik.values.infants?.map((infant, index) => (
                      <>
                        <Box
                          className={classes.root}
                          style={{
                            background: "white",
                            padding: "10px 15px",
                            border: "1px solid #e6e6e6",
                            marginTop: "10px",
                            boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                            borderRadius: "5px",
                          }}
                        >
                          <div>{`Enter the Detail of Infant.${index + 1}`}</div>
                          {/* <Field
														disabled
														type='text'
														name={`chil.${index}.firsName`}
														value={chil.firsName}
													/>
													<Field type='date' name={`chil.${index}.date`} /> */}
                          <Grid
                            container
                            spacing={2}
                            alignItems="center"
                            style={{ marginTop: 20, alignItems: "baseline" }}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              lg={3}
                              className={classes.root2}
                              style={{ alignItems: "center" }}
                            >
                              <Field
                                component={TextField}
                                select
                                name={`infant.${index}.title`}
                                type="text"
                                value={infant.title}
                                variant="outlined"
                                disabled
                                // label='Select Title'
                                // error={errors.titleC1}
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  className: classes.inputPropsStyle,
                                }}
                              >
                                {titleI.map((item, index) => (
                                  <MenuItem key={index} value={item}>
                                    {item}
                                  </MenuItem>
                                ))}
                              </Field>
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                              <Field
                                component={TextField}
                                name={`infant.${index}.firstname`}
                                type="text"
                                value={infant.firstname}
                                variant="outlined"
                                disabled
                                // error={errors.first_nameC1}
                                // label='Enter First Name'
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                              <Field
                                component={TextField}
                                name={`infant.${index}.lastname`}
                                type="text"
                                value={infant.lastname}
                                variant="outlined"
                                disabled
                                // error={errors.last_nameC1}
                                // label='Enter Last Name'
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                              <Field
                                component={TextField}
                                name={`infant.${index}.dob`}
                                type="date"
                                value={infant.dob}
                                variant="outlined"
                                disabled
                                // error={errors.last_nameC1}
                                // label='Enter Last Name'
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            {selectedOrigin.country_code === "IN" &&
                            selectedDepart.country_code === "IN" ? (
                              ""
                            ) : (
                              <>
                                <Grid item xs={12} sm={6} lg={4}>
                                  <Field
                                    component={TextField}
                                    name={`infant.${index}.passportnumber`}
                                    type="text"
                                    // error={errors.last_nameA1}
                                    variant="outlined"
                                    disabled
                                    value={infant.passportnumber}
                                    // label="Enter Passport Number"
                                    className={classes.selectField}
                                    InputProps={{
                                      className: classes.InputPropsStyle,
                                    }}
                                    inputProps={{
                                      style: { padding: 12 },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={4}>
                                  <Field
                                    component={TextField}
                                    name={`infant.${index}.expiry`}
                                    type="date"
                                    value={infant.expiry}
                                    disabled
                                    // error={errors.last_nameA1}
                                    variant="outlined"
                                    // label='Enter Passport Number'
                                    className={classes.selectField}
                                    InputProps={{
                                      className: classes.InputPropsStyle,
                                    }}
                                    inputProps={{
                                      style: { padding: 12 },
                                    }}
                                  />
                                </Grid>
                              </>
                            )}
                          </Grid>
                        </Box>
                      </>
                    ))}
                  </div>
                );
              }}
            />
            {/* Baggage Section Start*/}
            {location.state.OneflightData?.Supplier === "TBO" ||
            location.state.OneflightData?.Supplier === "TJK" ? (
              <>
                <Box
                  alignItems="center"
                  display="flex"
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <h4>Select Excess Baggage</h4>
                  <Select
                    style={{ width: "30%", marginLeft: 45 }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={age}
                    //   label="Age"
                    onChange={handleChange}
                  >
                    {location.state.OneflightData?.Supplier === "TBO"
                      ? ssrTBO &&
                        ssrTBO.result &&
                        ssrTBO.result.Response &&
                        ssrTBO.result.Response?.Baggage[0]?.map((item) => {
                          return (
                            <MenuItem
                              value={`${item.Weight} kg ₹ ${item.Price}`}
                              onClick={() => dispatch(setBaggage(item))}
                            >{`${item.Weight} kg ₹${item.Price}`}</MenuItem>
                          );
                        })
                      : location.state.OneflightData?.Supplier === "TJK"
                      ? farequotetripjack &&
					  farequotetripjack.result &&
					  farequotetripjack.result.tripInfos[0] &&
					  farequotetripjack.result.tripInfos[0]?.sI[0].ssrInfo?.BAGGAGE.map((item) => {
                          return (
                            <MenuItem
                              value={`${item.desc} kg ₹ ${item.amount}`}
                              onClick={() => dispatch(setBaggage(item))}
                            >{`${item.desc} kg ₹${item.amount}`}</MenuItem>
                          );
                        })
                      : ""}

                    {/* <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem> */}
                  </Select>
                </Box>
                {/* Baggage Section End*/}
                <Box
                  alignItems="center"
                  display="flex"
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <h4>Select Meal Preference</h4>
                  <Select
                    style={{ width: "30%", marginLeft: 45 }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={meal}
                    //   label="Age"
                    onChange={handleChangeMeal}
                  >
                    {location.state.OneflightData?.Supplier === "TBO"?ssrTBO &&
                      ssrTBO.result &&
                      ssrTBO.result.Response &&
                      ssrTBO.result.Response?.MealDynamic[0]?.map((item) => {
                        return (
                          <MenuItem
                            value={`${item.AirlineDescription}  ₹ ${item.Price}`}
                            onClick={() => dispatch(setMealInfo(item))}
                          >{`${item.AirlineDescription}  ₹${item.Price}`}</MenuItem>
                        );
                      }):location.state.OneflightData?.Supplier === "TJK"?farequotetripjack &&
					  farequotetripjack.result &&
					  farequotetripjack.result.tripInfos[0] &&
					  farequotetripjack.result.tripInfos[0]?.sI[0].ssrInfo?.MEAL.map((item) => {
                        return (
							<MenuItem
							value={`${item.desc} kg ₹ ${item.amount}`}
							onClick={() => dispatch(setMealInfo(item))}
						  >{`${item.desc} kg ₹${item.amount}`}</MenuItem>
                        );
                      }):''}

                    {/* <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem> */}
                  </Select>
                </Box>
              </>
            ) : (
              ""
            )}
            {/* payment method */}
            <Box
              alignItems="center"
              display="flex"
              style={{
                background: "white",
                padding: "10px 15px",
                border: "1px solid #e6e6e6",
                marginTop: "10px",
                boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                borderRadius: "5px",
              }}
            >
              {agentlogin &&
              agentlogin.result &&
              agentlogin.result.result &&
              agentlogin.result.result.role === "Agent" ? (
                // <></>
                <>
                  {location.state.OneflightData ? (
                    <>
                      {" "}
                      <FormControlLabel
                        style={{ marginRight: 0 }}
                        value="offline"
                        control={
                          <Radio
                            checked={offline}
                            onClick={handleHold}
                            disabled={
                              location.state.OneflightData.AirlineCode
                                ? Number(
                                    Math.round(
                                      location.state.OneflightData.Fare
                                        .Total_Amount
                                    )
                                  ) <
                                  Number(
                                    Math.round(
                                      walletagent &&
                                        walletagent.result.balanceAmount
                                    )
                                  )
                                  ? false
                                  : true
                                : location.state.OneflightData.Airline_Code
                                ? Number(
                                    Math.round(
                                      location.state.OneflightData.Fares
                                        .Total_Amount
                                    )
                                  ) <
                                  Number(
                                    Math.round(
                                      walletagent &&
                                        walletagent.result.balanceAmount
                                    )
                                  )
                                  ? false
                                  : true
                                : ""
                            }
                          />
                        }
                      />
                      <span
                        style={{
                          opacity: location.state.OneflightData.AirlineCode
                            ? Number(
                                Math.round(
                                  location.state.OneflightData.Fare.Total_Amount
                                )
                              ) <
                              Number(
                                Math.round(
                                  walletagent &&
                                    walletagent.result.balanceAmount
                                )
                              )
                              ? ""
                              : 0.3
                            : location.state.OneflightData.Airline_Code
                            ? Number(
                                Math.round(
                                  location.state.OneflightData.Fares
                                    .Total_Amount
                                )
                              ) <
                              Number(
                                Math.round(
                                  walletagent &&
                                    walletagent.result.balanceAmount
                                )
                              )
                              ? ""
                              : 0.3
                            : "",
                        }}
                      >
                        Offline Amount
                      </span>
                      <span
                        style={{
                          marginLeft: 5,
                          color: "blue",
                          opacity: location.state.OneflightData.AirlineCode
                            ? Number(
                                Math.round(
                                  location.state.OneflightData.Fare.Total_Amount
                                )
                              ) <
                              Number(
                                Math.round(
                                  walletagent &&
                                    walletagent.result.balanceAmount
                                )
                              )
                              ? ""
                              : 0.3
                            : location.state.OneflightData.Airline_Code
                            ? Number(
                                Math.round(
                                  location.state.OneflightData.Fares
                                    .Total_Amount
                                )
                              ) <
                              Number(
                                Math.round(
                                  walletagent &&
                                    walletagent.result.balanceAmount
                                )
                              )
                              ? ""
                              : 0.3
                            : "",
                        }}
                      >
                        {" "}
                        {location.state.OneflightData.AirlineCode
                          ? Number(
                              Math.round(
                                location.state.OneflightData.Fare.Total_Amount
                              )
                            ) -
                            Number(
                              Math.round(
                                location.state.OneflightData.Fare.MFB_Discount
                              )
                            )
                          : location.state.OneflightData.Airline_Code
                          ? Number(
                              Math.round(
                                location.state.OneflightData.Fares.Total_Amount
                              )
                            )
                          : ""}
                      </span>
                    </>
                  ) : (
                    <>
                      <FormControlLabel
                        style={{ marginRight: 0 }}
                        value="offline"
                        control={
                          <Radio
                            checked={offline}
                            onClick={handleHold}
                            disabled={
                              etrav2
                                ? Number(
                                    Number(
                                      Math.round(
                                        location.state.selectedReturn[0].Fares
                                          .Total_Amount
                                      )
                                    ) +
                                      Number(
                                        Math.round(
                                          location.state.selectedonward[0].Fares
                                            .Total_Amount
                                        )
                                      )
                                  ) <
                                  Number(
                                    Math.round(
                                      walletagent &&
                                        walletagent.result.balanceAmount
                                    )
                                  )
                                  ? false
                                  : true
                                : tbo2
                                ? Number(
                                    Number(
                                      Math.round(
                                        location.state.selectedReturn[0].Fare
                                          .Total_Amount
                                      )
                                    ) +
                                      Number(
                                        Math.round(
                                          location.state.selectedonward[0].Fare
                                            .Total_Amount
                                        )
                                      )
                                  ) <
                                  Number(
                                    Math.round(
                                      walletagent &&
                                        walletagent.result.balanceAmount
                                    )
                                  )
                                  ? false
                                  : true
                                : etrvotbor
                                ? Number(
                                    Number(
                                      Math.round(
                                        location.state.selectedReturn[0].Fare
                                          .Total_Amount
                                      )
                                    ) +
                                      Number(
                                        Math.round(
                                          location.state.selectedonward[0].Fares
                                            .Total_Amount
                                        )
                                      )
                                  ) <
                                  Number(
                                    Math.round(
                                      walletagent &&
                                        walletagent.result.balanceAmount
                                    )
                                  )
                                  ? false
                                  : true
                                : etravrtboo
                                ? Number(
                                    Number(
                                      Math.round(
                                        location.state.selectedReturn[0].Fares
                                          .Total_Amount
                                      )
                                    ) +
                                      Number(
                                        Math.round(
                                          location.state.selectedonward[0].Fare
                                            .Total_Amount
                                        )
                                      )
                                  ) <
                                  Number(
                                    Math.round(
                                      walletagent &&
                                        walletagent.result.balanceAmount
                                    )
                                  )
                                  ? false
                                  : true
                                : ""
                            }
                          />
                        }
                      />
                      <span
                        style={{
                          opacity: etrav2
                            ? Number(
                                Number(
                                  Math.round(
                                    location.state.selectedReturn[0].Fares
                                      .Total_Amount
                                  )
                                ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedonward[0].Fares
                                        .Total_Amount
                                    )
                                  )
                              ) <
                              Number(
                                Math.round(
                                  walletagent &&
                                    walletagent.result.balanceAmount
                                )
                              )
                              ? ""
                              : 0.3
                            : tbo2
                            ? Number(
                                Number(
                                  Math.round(
                                    location.state.selectedReturn[0].Fare
                                      .Total_Amount
                                  )
                                ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedonward[0].Fare
                                        .Total_Amount
                                    )
                                  )
                              ) <
                              Number(
                                Math.round(
                                  walletagent &&
                                    walletagent.result.balanceAmount
                                )
                              )
                              ? ""
                              : 0.3
                            : etrvotbor
                            ? Number(
                                Number(
                                  Math.round(
                                    location.state.selectedReturn[0].Fare
                                      .Total_Amount
                                  )
                                ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedonward[0].Fares
                                        .Total_Amount
                                    )
                                  )
                              ) <
                              Number(
                                Math.round(
                                  walletagent &&
                                    walletagent.result.balanceAmount
                                )
                              )
                              ? ""
                              : 0.3
                            : etravrtboo
                            ? Number(
                                Number(
                                  Math.round(
                                    location.state.selectedReturn[0].Fares
                                      .Total_Amount
                                  )
                                ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedonward[0].Fare
                                        .Total_Amount
                                    )
                                  )
                              ) <
                              Number(
                                Math.round(
                                  walletagent &&
                                    walletagent.result.balanceAmount
                                )
                              )
                              ? ""
                              : 0.3
                            : "",
                        }}
                      >
                        Offline Amount
                      </span>
                      <span
                        style={{
                          marginLeft: 5,
                          opacity: etrav2
                            ? Number(
                                Number(
                                  Math.round(
                                    location.state.selectedReturn[0].Fares
                                      .Total_Amount
                                  )
                                ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedonward[0].Fares
                                        .Total_Amount
                                    )
                                  )
                              ) <
                              Number(
                                Math.round(
                                  walletagent &&
                                    walletagent.result.balanceAmount
                                )
                              )
                              ? ""
                              : 0.3
                            : tbo2
                            ? Number(
                                Number(
                                  Math.round(
                                    location.state.selectedReturn[0].Fare
                                      .Total_Amount
                                  )
                                ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedonward[0].Fare
                                        .Total_Amount
                                    )
                                  )
                              ) <
                              Number(
                                Math.round(
                                  walletagent &&
                                    walletagent.result.balanceAmount
                                )
                              )
                              ? ""
                              : 0.3
                            : "",
                        }}
                      >
                        {" "}
                        {etrav2
                          ? Number(
                              Number(
                                Math.round(
                                  location.state.selectedReturn[0].Fares
                                    .Total_Amount
                                )
                              ) +
                                Number(
                                  Math.round(
                                    location.state.selectedonward[0].Fares
                                      .Total_Amount
                                  )
                                )
                            )
                          : tbo2
                          ? Number(
                              Number(
                                Math.round(
                                  location.state.selectedReturn[0].Fare
                                    .Total_Amount
                                )
                              ) +
                                Number(
                                  Math.round(
                                    location.state.selectedonward[0].Fare
                                      .Total_Amount
                                  )
                                )
                            )
                          : etrvotbor
                          ? Number(
                              Number(
                                Math.round(
                                  location.state.selectedReturn[0].Fare
                                    .Total_Amount
                                )
                              ) +
                                Number(
                                  Math.round(
                                    location.state.selectedonward[0].Fares
                                      .Total_Amount
                                  )
                                )
                            )
                          : etravrtboo
                          ? Number(
                              Number(
                                Math.round(
                                  location.state.selectedReturn[0].Fares
                                    .Total_Amount
                                )
                              ) +
                                Number(
                                  Math.round(
                                    location.state.selectedonward[0].Fare
                                      .Total_Amount
                                  )
                                )
                            )
                          : ""}
                      </span>
                    </>
                  )}
                  {/* <FormControlLabel
											style={{ marginRight: 0, marginLeft: 10 }}
											value='hold'
											control={
												<Radio
													checked={hold}
													onClick={handleHold}
													style={{ marginLeft: 10 }}
												/>
											}
											// label='Hold'
										/>
										<span>Hold</span> */}
                </>
              ) : (
                ""
              )}

              <FormControlLabel
                style={{ marginRight: 0, marginLeft: 10 }}
                value="pay"
                control={
                  <Radio
                    checked={pay}
                    onClick={handleHold}
                    style={{ marginLeft: 10 }}
                  />
                }
                // label='Pay Online'
              />
              <span>Pay With Razorpay</span>
              <span style={{ marginLeft: 5, color: "blue" }}>
                {location.state.OneflightData
                  ? location.state.OneflightData.Supplier === "ETR"
                    ? Number(
                        Math.round(
                          location.state.OneflightData.Fares.Total_Amount
                        )
                      ) -
                      Number(
                        Math.round(
                          location.state.OneflightData.Fares.agentMarkup
                        )
                      ) +
                      Number(
                        Math.round(
                          (Number(
                            Number(
                              Math.round(
                                location.state.OneflightData.Fares.Total_Amount
                              )
                            ) -
                              Number(
                                Math.round(
                                  location.state.OneflightData.Fares.agentMarkup
                                )
                              )
                          ) *
                            2.5) /
                            100
                        )
                      )+Number(Math.round(baggageInfo[0]?.AirlineCode?baggageInfo[0]?.Price:baggageInfo[0]?.code?baggageInfo[0]?.amount:0))+Number(Math.round(mealInfo[0]?.AirlineCode?mealInfo[0]?.Price:mealInfo[0]?.code?mealInfo[0]?.amount:0))
                    : location.state.OneflightData.Supplier === "TBO"
                    ? Number(
                        Math.round(
                          location.state.OneflightData.Fare.Total_Amount
                        )
                      ) -
                      Number(
                        Math.round(
                          location.state.OneflightData.Fare.agentMarkup
                        )
                      ) +
                      Number(
                        Math.round(
                          (Number(
                            Number(
                              Math.round(
                                location.state.OneflightData.Fare.Total_Amount
                              )
                            ) -
                              Number(
                                Math.round(
                                  location.state.OneflightData.Fare.agentMarkup
                                )
                              )
                          ) *
                            2.5) /
                            100
                        )
                      )+Number(Math.round(baggageInfo[0]?.AirlineCode?baggageInfo[0]?.Price:baggageInfo[0]?.code?baggageInfo[0]?.amount:0))+Number(Math.round(mealInfo[0]?.AirlineCode?mealInfo[0]?.Price:mealInfo[0]?.code?mealInfo[0]?.amount:0))
                    : location.state.OneflightData.Supplier === "TJK"
                    ? Number(
                        Math.round(
                          location.state.OneflightData.totalPriceList.fd
                            .Total_Amount
                        )
                      ) -
                      Number(
                        Math.round(
                          location.state.OneflightData.totalPriceList.fd
                            .agentMarkup
                        )
                      ) +
                      Number(
                        Math.round(
                          (Number(
                            Number(
                              Math.round(
                                location.state.OneflightData.totalPriceList.fd
                                  .Total_Amount
                              )
                            ) -
                              Number(
                                Math.round(
                                  location.state.OneflightData.totalPriceList.fd
                                    .agentMarkup
                                )
                              )
                          ) *
                            2.5) /
                            100
                        )
                      )+Number(Math.round(baggageInfo[0]?.AirlineCode?baggageInfo[0]?.Price:baggageInfo[0]?.code?baggageInfo[0]?.amount:0))+Number(Math.round(mealInfo[0]?.AirlineCode?mealInfo[0]?.Price:mealInfo[0]?.code?mealInfo[0]?.amount:0))
                    : ""
                  : location.state.intFlight?.Supplier === "TBO"
                  ? Number(
                      Math.round(location.state.intFlight.Fare.Total_Amount)
                    ) -
                    Number(
                      Math.round(location.state.intFlight.Fare.agentMarkup)
                    ) +
                    Number(
                      (Number(
                        Number(
                          Math.round(location.state.intFlight.Fare.Total_Amount)
                        ) -
                          Number(
                            Math.round(
                              location.state.intFlight.Fare.agentMarkup
                            )
                          )
                      ) *
                        2.5) /
                        100
                    )
                  : Number(
                      Number(
                        Math.round(
                          location.state.selectedonward[0].Airline_Code
                            ? location.state.selectedonward[0].Fares
                                .Total_Amount
                            : location.state.selectedonward[0].AirlineCode
                            ? location.state.selectedonward[0].Fare.Total_Amount
                            : 0
                        )
                      ) +
                        Number(
                          Math.round(
                            location.state.selectedReturn[0].Airline_Code
                              ? location.state.selectedReturn[0].Fares
                                  .Total_Amount
                              : location.state.selectedonward[0].AirlineCode
                              ? location.state.selectedReturn[0].Fare
                                  .Total_Amount
                              : 0
                          ) -
                            Number(
                              Math.round(
                                location.state.selectedReturn[0].Airline_Code
                                  ? 0
                                  : location.state.selectedonward[0].AirlineCode
                                  ? location.state.selectedReturn[0].Fare
                                      .MFB_Discount
                                  : 0
                              )
                            ) -
                            Number(
                              Math.round(
                                location.state.selectedonward[0].Airline_Code
                                  ? 0
                                  : location.state.selectedonward[0].AirlineCode
                                  ? location.state.selectedonward[0].Fare
                                      .MFB_Discount
                                  : 0
                              )
                            )
                        ) +
                        (Number(
                          Number(
                            Math.round(
                              location.state.selectedonward[0].Airline_Code
                                ? location.state.selectedonward[0].Fares
                                    .Total_Amount
                                : location.state.selectedonward[0].AirlineCode
                                ? location.state.selectedonward[0].Fare
                                    .Total_Amount
                                : 0
                            )
                          ) +
                            Number(
                              Math.round(
                                location.state.selectedReturn[0].Airline_Code
                                  ? location.state.selectedReturn[0].Fares
                                      .Total_Amount
                                  : location.state.selectedonward[0].AirlineCode
                                  ? location.state.selectedReturn[0].Fare
                                      .Total_Amount
                                  : 0
                              )
                            ) -
                            Number(
                              Math.round(
                                location.state.selectedReturn[0].Airline_Code
                                  ? 0
                                  : location.state.selectedonward[0].AirlineCode
                                  ? location.state.selectedReturn[0].Fare
                                      .MFB_Discount
                                  : 0
                              )
                            ) -
                            Number(
                              Math.round(
                                location.state.selectedonward[0].Airline_Code
                                  ? 0
                                  : location.state.selectedonward[0].AirlineCode
                                  ? location.state.selectedonward[0].Fare
                                      .MFB_Discount
                                  : 0
                              )
                            )
                        ) *
                          2.5) /
                          100
                    )}
              </span>
              {/* <FormControlLabel
                  style={{ marginRight: 0, marginLeft: 10 }}
                  value="payworldline"
                  control={
                    <Radio
                      checked={payworldline}
                      onClick={handleHold}
                      style={{ marginLeft: 10 }}
                    />
                  }
                  // label='Pay Online'
                />
                <span>Pay With Worline</span>
                <span style={{ marginLeft: 5, color: "blue" }}>
                  {" "}
                  {location.state.OneflightData.Supplier === "TBO"
                    ? Number(
                        Math.round(
                          location.state.OneflightData.Fare.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fare.agentMarkup)) + Number(Math.round(Number(Number(
                        Math.round(
                          location.state.OneflightData.Fare.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fare.agentMarkup)))*2.5/100))
                    : Number(
                        Math.round(
                          location.state.OneflightData.Fares.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fares.agentMarkup)) + Number(Math.round(Number(Number(
                        Math.round(
                          location.state.OneflightData.Fares.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fares.agentMarkup)))*2.5/100))}
                </span> */}
            </Box>
            {/* Submit and Edit Button */}
            <Grid
              container
              spacing={2}
              style={{ marginBottom: 60, marginTop: 20 }}
            >
              <Grid item xs={4} lg={2}>
                <Button
                  className={classes.createButton}
                  onClick={edit}
                  style={{ marginTop: 10, fontSize: 14 }}
                  // disabled={isSubmitting}
                >
                  EDIT
                </Button>
              </Grid>
              <Grid item xs={8} lg={4}>
                <Button
                  className={classes.createButton}
                  onClick={handleFormSubmit}
                  style={{ marginTop: 10, fontSize: 14 }}
                  // disabled={isSubmitting}
                >
                  PROCESS TO PAYMENT
                </Button>
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>
          </Form>
        )}
      </Formik>
      {/* <ErrorModal /> */}
      <WorldlinePG />
      <BookingAlreadyPNRModal />
    </>
  );
};

export default FlightConfirmForm;
